module.exports = __webpack_public_path__ + "img/preview-image.541d405.svg";